import e, { Component as t } from "react";
import { TypeaheadStateless as n } from "./TypeaheadStateless.js";
import { unconcurrent as r } from "../../../utils/unconcurrent/unconcurrent.js";
import { Spinner as o } from "../../loaders/Spinner/Spinner.js";
function u(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function i(e, t, n, r, o, u, i) {
  try {
    var s = e[u](i),
      a = s.value;
  } catch (e) {
    n(e);
    return;
  }
  s.done ? t(a) : Promise.resolve(a).then(r, o);
}
function s(e) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (r, o) {
      var u = e.apply(t, n);
      function s(e) {
        i(u, r, o, s, a, "next", e);
      }
      function a(e) {
        i(u, r, o, s, a, "throw", e);
      }
      s(void 0);
    });
  };
}
function a(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function c(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function l(e) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function f(e, t) {
  return (f = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function p(e, t) {
  var n,
    r,
    o,
    u,
    i = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
  return u = {
    next: s(0),
    throw: s(1),
    return: s(2)
  }, "function" == typeof Symbol && (u[Symbol.iterator] = function () {
    return this;
  }), u;
  function s(u) {
    return function (s) {
      return function (u) {
        if (n) throw TypeError("Generator is already executing.");
        for (; i;) try {
          if (n = 1, r && (o = 2 & u[0] ? r.return : u[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, u[1])).done) return o;
          switch (r = 0, o && (u = [2 & u[0], o.value]), u[0]) {
            case 0:
            case 1:
              o = u;
              break;
            case 4:
              return i.label++, {
                value: u[1],
                done: !1
              };
            case 5:
              i.label++, r = u[1], u = [0];
              continue;
            case 7:
              u = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!(o = (o = i.trys).length > 0 && o[o.length - 1]) && (6 === u[0] || 2 === u[0])) {
                i = 0;
                continue;
              }
              if (3 === u[0] && (!o || u[1] > o[0] && u[1] < o[3])) {
                i.label = u[1];
                break;
              }
              if (6 === u[0] && i.label < o[1]) {
                i.label = o[1], o = u;
                break;
              }
              if (o && i.label < o[2]) {
                i.label = o[2], i.ops.push(u);
                break;
              }
              o[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          u = t.call(e, i);
        } catch (e) {
          u = [6, e], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & u[0]) throw u[1];
        return {
          value: u[0] ? u[1] : void 0,
          done: !0
        };
      }([u, s]);
    };
  }
}
var h = function h(e, t) {
    return void 0 !== e ? e : t;
  },
  g = function (t) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && f(e, t);
    }(v, t);
    var i,
      g,
      y,
      d = (i = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
          t,
          n = l(v);
        if (i) {
          var r = l(this).constructor;
          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);
        return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : u(this);
      });
    function v(e, t) {
      !function (e, t) {
        if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
      }(this, v), c(u(o = d.call(this, e, t)), "state", {
        open: !1,
        suggestions: [],
        value: ""
      }), c(u(o), "getSuggestions", void 0), c(u(o), "handleFocus", function () {
        o.setState({
          open: !0
        }), o.fetchSuggestions(o.state.value);
      }), c(u(o), "handleBlur", function () {
        return o.setState({
          open: !1
        });
      });
      var n,
        o,
        i = u(o);
      return c(u(o), "handleChange", (n = s(function (e) {
        var t, n;
        return p(this, function (r) {
          return i.setState({
            value: e
          }), null === (t = (n = i.props).onChange) || void 0 === t || t.call(n, e), i.fetchSuggestions(e), [2];
        });
      }), function (e) {
        return n.apply(this, arguments);
      })), c(u(o), "handleItemPicked", function (e, t) {
        var n, r;
        null === (n = (r = o.props).onItemPicked) || void 0 === n || n.call(r, e, t);
      }), o.getSuggestions = r(function (e) {
        return o.props.getSuggestions(e);
      }), o;
    }
    return g = [{
      key: "fetchSuggestions",
      value: function value(e) {
        var t = this;
        return s(function () {
          var n;
          return p(this, function (r) {
            switch (r.label) {
              case 0:
                return t.setState({
                  pending: !0
                }), [4, t.getSuggestions(e)];
              case 1:
                return n = r.sent(), t.setState({
                  suggestions: n,
                  pending: !1
                }), [2];
            }
          });
        })();
      }
    }, {
      key: "render",
      value: function value() {
        var t = h(this.props.pending, this.state.pending);
        return e.createElement(n, {
          open: h(this.props.open, this.state.open),
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onChange: this.handleChange,
          onItemPicked: this.handleItemPicked,
          value: h(this.props.value, this.state.value),
          suggestions: this.state.suggestions,
          suggestionsTemplate: this.props.suggestionsTemplate
        }, t && e.createElement(o, null), !t && this.props.children);
      }
    }], a(v.prototype, g), y && a(v, y), v;
  }(t);
export { g as TypeaheadStateful };